export default __webpack_public_path__ + "static/media/tfg-img.476278af.webp";